// extracted by mini-css-extract-plugin
module.exports = {"MainDiv":"SchoolInfoPage_MainDiv__2w_LR"};